module.exports = __webpack_public_path__ + "img/BG.d4ef0463.svg";